import React, { useState, useEffect } from 'react';
import './TeacherSettings.css';
import DashboardHeader from '../components/DashboardHeader';
import TeacherNavigationBar from '../components/TeacherNavigationBar';

function TeacherSettings() {
  const [teacherInfo, setTeacherInfo] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    specialite: '',
    diplome: '',
    experience: ''
  });

  const [preferences, setPreferences] = useState({
    notifications_email: true,
    notifications_sms: false,
    rappel_notes: true,
    rappel_absences: true,
    theme: 'light'
  });

  const [password, setPassword] = useState({
    current: '',
    new: '',
    confirm: ''
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [activeTab, setActiveTab] = useState('profile');

  useEffect(() => {
    loadTeacherInfo();
  }, []);

  const loadTeacherInfo = async () => {
    setLoading(true);
    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/profile');
      const data = await response.json();

      if (response.ok) {
        setTeacherInfo(data.data || data);
      }
    } catch (error) {
      console.error('Erreur:', error);
      // Données de test
      setTeacherInfo({
        nom: 'Dupont',
        prenom: 'Jean',
        email: 'jean.dupont@lycee.com',
        telephone: '+229 01 23 45 67',
        specialite: 'Mathématiques',
        diplome: 'Master en Didactique des Mathématiques',
        experience: '10 ans'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTeacherInfoChange = (field, value) => {
    setTeacherInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePreferenceChange = (field, value) => {
    setPreferences(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePasswordChange = (field, value) => {
    setPassword(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const saveTeacherInfo = async () => {
    if (!teacherInfo.email || !teacherInfo.nom) {
      alert('Veuillez remplir les champs obligatoires');
      return;
    }

    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(teacherInfo)
      });

      if (response.ok) {
        setSuccessMessage('Profil mis à jour avec succès');
        setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la mise à jour');
    }
  };

  const savePreferences = async () => {
    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/preferences', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(preferences)
      });

      if (response.ok) {
        setSuccessMessage('Préférences mises à jour avec succès');
        setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la mise à jour');
    }
  };

  const changePassword = async () => {
    if (!password.current || !password.new || !password.confirm) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    if (password.new !== password.confirm) {
      alert('Les nouveaux mots de passe ne correspondent pas');
      return;
    }

    if (password.new.length < 8) {
      alert('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/change-password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          current_password: password.current,
          new_password: password.new
        })
      });

      if (response.ok) {
        setPassword({ current: '', new: '', confirm: '' });
        setSuccessMessage('Mot de passe changé avec succès');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        alert('Erreur: mot de passe actuel incorrect');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du changement de mot de passe');
    }
  };

  return (
    <div className="teacher-settings">
      <DashboardHeader />
      <TeacherNavigationBar 
        title="Paramètres" 
        onBack={() => window.navigateTo && window.navigateTo('teacher-dashboard')}
      />
      <div className="settings-container">
        <main className="settings-main admin-content-full">
          <div className="settings-header" style={{display: 'none'}}>
            <h1>Paramètres</h1>
            <p>Gérez votre profil et vos préférences</p>
          </div>

          {successMessage && (
            <div className="success-message">
              ✓ {successMessage}
            </div>
          )}

          <div className="settings-tabs">
            <button
              className={`tab ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => setActiveTab('profile')}
            >
              👤 Mon Profil
            </button>
            <button
              className={`tab ${activeTab === 'preferences' ? 'active' : ''}`}
              onClick={() => setActiveTab('preferences')}
            >
              ⚙️ Préférences
            </button>
            <button
              className={`tab ${activeTab === 'password' ? 'active' : ''}`}
              onClick={() => setActiveTab('password')}
            >
              🔒 Mot de passe
            </button>
          </div>

          <div className="settings-content">
            {activeTab === 'profile' && (
              <div className="settings-panel">
                <h2>Informations Personnelles</h2>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Nom *</label>
                    <input
                      type="text"
                      value={teacherInfo.nom}
                      onChange={(e) => handleTeacherInfoChange('nom', e.target.value)}
                      placeholder="Votre nom"
                    />
                  </div>

                  <div className="form-group">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      value={teacherInfo.prenom}
                      onChange={(e) => handleTeacherInfoChange('prenom', e.target.value)}
                      placeholder="Votre prénom"
                    />
                  </div>

                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      value={teacherInfo.email}
                      onChange={(e) => handleTeacherInfoChange('email', e.target.value)}
                      placeholder="votre@email.com"
                    />
                  </div>

                  <div className="form-group">
                    <label>Téléphone</label>
                    <input
                      type="tel"
                      value={teacherInfo.telephone}
                      onChange={(e) => handleTeacherInfoChange('telephone', e.target.value)}
                      placeholder="+229 XX XX XX XX"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Spécialité</label>
                    <input
                      type="text"
                      value={teacherInfo.specialite}
                      onChange={(e) => handleTeacherInfoChange('specialite', e.target.value)}
                      placeholder="Ex: Mathématiques"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Diplôme</label>
                    <input
                      type="text"
                      value={teacherInfo.diplome}
                      onChange={(e) => handleTeacherInfoChange('diplome', e.target.value)}
                      placeholder="Ex: Master en Mathématiques"
                    />
                  </div>

                  <div className="form-group full-width">
                    <label>Expérience</label>
                    <input
                      type="text"
                      value={teacherInfo.experience}
                      onChange={(e) => handleTeacherInfoChange('experience', e.target.value)}
                      placeholder="Ex: 10 ans d'expérience"
                    />
                  </div>
                </div>

                <button className="btn btn-primary" onClick={saveTeacherInfo}>
                  Enregistrer les modifications
                </button>
              </div>
            )}

            {activeTab === 'preferences' && (
              <div className="settings-panel">
                <h2>Préférences de Notification</h2>
                <div className="preferences-list">
                  <div className="preference-item">
                    <div>
                      <h3>Notifications par Email</h3>
                      <p>Recevez les notifications importantes par email</p>
                    </div>
                    <label className="toggle">
                      <input
                        type="checkbox"
                        checked={preferences.notifications_email}
                        onChange={(e) => handlePreferenceChange('notifications_email', e.target.checked)}
                      />
                      <span></span>
                    </label>
                  </div>

                  <div className="preference-item">
                    <div>
                      <h3>Notifications SMS</h3>
                      <p>Recevez les notification urgentes par SMS</p>
                    </div>
                    <label className="toggle">
                      <input
                        type="checkbox"
                        checked={preferences.notifications_sms}
                        onChange={(e) => handlePreferenceChange('notifications_sms', e.target.checked)}
                      />
                      <span></span>
                    </label>
                  </div>

                  <div className="preference-item">
                    <div>
                      <h3>Rappels de Notes</h3>
                      <p>Recevoir des rappels pour soumettre les notes</p>
                    </div>
                    <label className="toggle">
                      <input
                        type="checkbox"
                        checked={preferences.rappel_notes}
                        onChange={(e) => handlePreferenceChange('rappel_notes', e.target.checked)}
                      />
                      <span></span>
                    </label>
                  </div>

                  <div className="preference-item">
                    <div>
                      <h3>Rappels d'Absences</h3>
                      <p>Recevoir des rappels pour enregistrer les absences</p>
                    </div>
                    <label className="toggle">
                      <input
                        type="checkbox"
                        checked={preferences.rappel_absences}
                        onChange={(e) => handlePreferenceChange('rappel_absences', e.target.checked)}
                      />
                      <span></span>
                    </label>
                  </div>

                  <div className="preference-item">
                    <div>
                      <h3>Thème</h3>
                      <p>Choisissez le thème de l'interface</p>
                    </div>
                    <select
                      value={preferences.theme}
                      onChange={(e) => handlePreferenceChange('theme', e.target.value)}
                    >
                      <option value="light">Clair</option>
                      <option value="dark">Sombre</option>
                      <option value="auto">Auto</option>
                    </select>
                  </div>
                </div>

                <button className="btn btn-primary" onClick={savePreferences}>
                  Enregistrer les préférences
                </button>
              </div>
            )}

            {activeTab === 'password' && (
              <div className="settings-panel">
                <h2>Changer le Mot de Passe</h2>
                <div className="password-form">
                  <div className="form-group">
                    <label>Mot de passe actuel *</label>
                    <input
                      type="password"
                      value={password.current}
                      onChange={(e) => handlePasswordChange('current', e.target.value)}
                      placeholder="Entrez votre mot de passe actuel"
                    />
                  </div>

                  <div className="form-group">
                    <label>Nouveau mot de passe *</label>
                    <input
                      type="password"
                      value={password.new}
                      onChange={(e) => handlePasswordChange('new', e.target.value)}
                      placeholder="Minimum 8 caractères"
                    />
                  </div>

                  <div className="form-group">
                    <label>Confirmer le mot de passe *</label>
                    <input
                      type="password"
                      value={password.confirm}
                      onChange={(e) => handlePasswordChange('confirm', e.target.value)}
                      placeholder="Confirmez le nouveau mot de passe"
                    />
                  </div>

                  <div className="password-tips">
                    <p>Conseils pour un mot de passe sûr:</p>
                    <ul>
                      <li>Au moins 8 caractères</li>
                      <li>Mélangez majuscules et minuscules</li>
                      <li>Incluez des chiffres et symboles</li>
                      <li>Evitez les informations personnelles</li>
                    </ul>
                  </div>

                  <button className="btn btn-primary" onClick={changePassword}>
                    Changer le mot de passe
                  </button>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default TeacherSettings;
